module.exports = __webpack_public_path__ + "img/legendary-lisboa-suites.fb40b564.jpg";